import {
  TriggerHoldUntilReplyRuleType,
  TriggerHoldUntilReplyRuleValue,
} from 'modules/workflows/constants/nodes/holdUntilReply';

export const TRIGGER_RULE_TYPE = 'triggerRuleType';
export const HAS_OTHER_REPLY = 'hasOtherReply';
export const CAMPAIGN_ID = 'campaignId';
export const REPLIES = 'replies';
export const HOLD_DURATION = 'holdDuration';
export const CUSTOM_DURATION = 'customDuration';

/** Default RHF values */
export const DEFAULT_CAMPAIGN_ID = '';
export const DEFAULT_REPLIES = [{ variants: [{ variant: '', readOnly: false }] }];
export const DEFAULT_TRIGGER_RULE_TYPE = TriggerHoldUntilReplyRuleType.SMS;
export const DEFAULT_HAS_OTHER_REPLY = true;
export const DEFAULT_HOLD_DURATION = { expireDays: 0, expireHours: 0, expireMinutes: 0 };

export const TRIGGER_RULE_TYPE_TO_MEDIUM = {
  [TriggerHoldUntilReplyRuleType.SMS]: TriggerHoldUntilReplyRuleValue.SMS,
  [TriggerHoldUntilReplyRuleType.WHATSAPP]: TriggerHoldUntilReplyRuleValue.WHATSAPP,
};

/** Hold duration */
export const TIME_IN_MINUTES = {
  FIVE: 5,
  FIFTEEN: 15,
  HOUR: 60,
  DAY: 1440,
  THREE_DAYS: 4320,
  WEEK: 10080,
};

export const PRESET_DURATION_MINUTES = [
  TIME_IN_MINUTES.FIVE,
  TIME_IN_MINUTES.FIFTEEN,
  TIME_IN_MINUTES.HOUR,
  TIME_IN_MINUTES.DAY,
  TIME_IN_MINUTES.THREE_DAYS,
  TIME_IN_MINUTES.WEEK,
];

export const CUSTOM_DURATION_VALUE = -1;
